import { AnimatePresence, motion } from 'motion/react';
import { BagAuditFooter } from './audit-footer';
import { BagAuditContextProvider } from './context';
import { useBagAuditContext } from './hook';
import { BagAuditFormPage } from './subroutes/audit-form';
import { BagAuditAddLoadPhotosPage } from './subroutes/audit-photos';
import { BagAuditScanPage } from './subroutes/audit-scan';
import type { BagAuditPageType } from './types';

export const FacilityBagAuditPage = () => {
	return (
		<BagAuditContextProvider>
			<BagAuditPageRoot />
		</BagAuditContextProvider>
	);
};

const BagAuditPageRoot = () => {
	return (
		<AnimatePresence>
			<SubRoute id="SCAN" component={<BagAuditScanPage />} />
			<SubRoute id="FORM" component={<BagAuditFormPage />} />
			<SubRoute id="PHOTOS" component={<BagAuditAddLoadPhotosPage />} />
			<BagAuditFooter />
		</AnimatePresence>
	);
};

const SubRoute = ({ id, component }: { id: BagAuditPageType; component: React.ReactNode }) => {
	const { page } = useBagAuditContext();

	if (page !== id) return null;

	return (
		<motion.div
			key={id}
			initial={{ opacity: 0 }}
			animate={{ opacity: 1 }}
			exit={{ opacity: 0 }}
			transition={{ duration: 0.3 }}
		>
			{component}
		</motion.div>
	);
};
